import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../../core/sdk';
import { Button } from 'primereact/button';
import { useEffect } from 'react';
import EmployeeMenuStore from './EmployeeMenuStore';

const EmployeeMenu = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    useEffect(() => {
        sdk.useStore(EmployeeMenuStore);
    }, [sdk]);
    const menu = sdk?.filteredMenuData || [];

    return (
        <div
            style={{
                padding: '1rem',
                maxWidth: '600px',
                margin: '0 auto',
                width: '100%',
            }}
        >
            {menu.map((item: any, index: number) => (
                <Button
                    key={item.key || index}
                    label={item.label}
                    icon={item.icon}
                    size="large"
                    className="employee-menu-button"
                    style={{
                        width: '100%',
                        marginBottom: '1.5rem',
                        padding: '1.25rem 1.5rem',
                        fontSize: '1.2rem',
                        fontWeight: '600',
                        height: '72px',
                        borderRadius: '12px',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                    onClick={() => {
                        if (item.type === 'external') {
                            window.open(item.path, '_blank');
                        } else if (item.type === 'iframe') {
                            sdk.routeTo(`/employee/iframe/${item.key}`);
                        } else {
                            // Default route navigation
                            sdk.routeTo(item.path);
                        }
                    }}
                />
            ))}
        </div>
    );
});

export default EmployeeMenu;
